import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "d-flex flex-column justify-content-between h-100" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "col-12 mb-2" }
const _hoisted_4 = { class: "align-items-center pt-3 border-top border-1 border-black border-opacity-25 mb-2" }
const _hoisted_5 = { class: "align-items-center pt-3 border-top border-1 border-black border-opacity-25 mb-2" }
const _hoisted_6 = { class: "col-9 col-xl" }
const _hoisted_7 = { class: "fs-6 fw-700 mb-2" }
const _hoisted_8 = { class: "align-items-center pt-3 border-top border-1 border-black border-opacity-25 mb-2" }
const _hoisted_9 = { class: "col-9 col-xl" }
const _hoisted_10 = { class: "fs-6 fw-700 mb-2" }
const _hoisted_11 = { class: "d-flex flex-column" }
const _hoisted_12 = { class: "row align-items-center pt-3 border-top border-1 border-black border-opacity-25 flex-nowrap" }
const _hoisted_13 = { class: "col-auto" }
const _hoisted_14 = {
  type: "submit",
  class: "btn btn-primary"
}
const _hoisted_15 = {
  key: 0,
  class: "flex-shrink-1"
}
const _hoisted_16 = { class: "col-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertError2 = _resolveComponent("AlertError2")!
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_SelectCategories = _resolveComponent("SelectCategories")!
  const _component_input_select = _resolveComponent("input-select")!
  const _component_AutoSaveFeedback = _resolveComponent("AutoSaveFeedback")!
  const _component_base_offcanvas_button_close = _resolveComponent("base-offcanvas-button-close")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertError2, {
      error: _ctx.pageUI.getError()
    }, null, 8, ["error"]),
    (!_ctx.pageUI.getIsReady())
      ? (_openBlock(), _createBlock(_component_base_spinner, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Form, { novalidate: "" }, {
        default: _withCtx(({ errors, handleSubmit }) => [
          _createElementVNode("form", {
            onSubmit: _withModifiers(($event: any) => (handleSubmit(_ctx.submitData)), ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allLanguages, (lang) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: lang,
                    class: "col-12"
                  }, [
                    _createVNode(_component_InputText, {
                      modelValue: _ctx.category.name[lang],
                      "onUpdate:modelValue": ($event: any) => ((_ctx.category.name[lang]) = $event),
                      modelModifiers: { trim: true },
                      label: `${_ctx.$t('name')} ${lang}`,
                      name: `name${lang}`,
                      rules: `atLeastOneMultilingualField:name,${_ctx.allLanguages.join('-')},${_ctx.$t('name')}|max:255`,
                      errors: errors,
                      onChange: _ctx.onCategoryChanged
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "name", "rules", "errors", "onChange"])
                  ]))
                }), 128))
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('parentCategoryDPManaged')), 1),
                    _createVNode(_component_SelectCategories, {
                      "selected-product-categories": _ctx.dpManagedParents,
                      excludedCodes: _ctx.excludedCategoryCodes,
                      onAddCategory: _ctx.setDpManagedCategory,
                      onRemoveCategory: _ctx.removeDpManagedCategory
                    }, null, 8, ["selected-product-categories", "excludedCodes", "onAddCategory", "onRemoveCategory"])
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('parentCustomerCategory')), 1),
                    _createVNode(_component_input_select, {
                      modelValue: _ctx.category.parent_code,
                      "onUpdate:modelValue": [
                        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.category.parent_code) = $event)),
                        _ctx.setParentCustomerCategory
                      ],
                      name: _ctx.$t('parentCustomerCategory'),
                      label: _ctx.$t('parentCustomerCategory'),
                      options: _ctx.customerCategories,
                      errors: errors,
                      rules: { parent_required: { otherField: _ctx.category.dp_managed_parent_category_code } },
                      "can-clear": true
                    }, null, 8, ["modelValue", "name", "label", "options", "errors", "rules", "onUpdate:modelValue"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("button", _hoisted_14, _toDisplayString(_ctx.$t('save')), 1)
                ]),
                (_ctx.autoSaveFeedbackStatus !== _ctx.AutoSaveFeedbackStatusEnum.NONE)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createVNode(_component_AutoSaveFeedback, { status: _ctx.autoSaveFeedbackStatus }, null, 8, ["status"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_base_offcanvas_button_close, {
                    ref: "closeButton",
                    class: "btn btn-light"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('close')), 1)
                    ]),
                    _: 1
                  }, 512)
                ])
              ])
            ])
          ], 40, _hoisted_2)
        ]),
        _: 1
      })
    ])
  ], 64))
}